/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Testimonial_3_NameInputs */

const en_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-Tier Intelligence`)
};

const de_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweistufige Intelligenz`)
};

const fr_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence à deux niveaux`)
};

const es_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia de dos niveles`)
};

const it_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligenza a due livelli`)
};

const nl_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tweelaagse intelligentie`)
};

const pl_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dwupoziomowa inteligencja`)
};

const fi_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaksitasoinen älykkyys`)
};

const da_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To-lags intelligens`)
};

const sv_landing_testimonial_3_name = /** @type {(inputs: Landing_Testimonial_3_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tvåstegs-intelligens`)
};

/**
* | output |
* | --- |
* | "Two-Tier Intelligence" |
*
* @param {Landing_Testimonial_3_NameInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_testimonial_3_name = /** @type {((inputs?: Landing_Testimonial_3_NameInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Testimonial_3_NameInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_testimonial_3_name(inputs)
	if (locale === "fr") return fr_landing_testimonial_3_name(inputs)
	if (locale === "es") return es_landing_testimonial_3_name(inputs)
	if (locale === "it") return it_landing_testimonial_3_name(inputs)
	if (locale === "nl") return nl_landing_testimonial_3_name(inputs)
	if (locale === "pl") return pl_landing_testimonial_3_name(inputs)
	if (locale === "fi") return fi_landing_testimonial_3_name(inputs)
	if (locale === "da") return da_landing_testimonial_3_name(inputs)
	if (locale === "sv") return sv_landing_testimonial_3_name(inputs)
	return en_landing_testimonial_3_name(inputs)
});